module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustration-3-3ff8fd7f923cde4866fafffb4c1c7c22.png";